module.exports = "/_next/static/images/HeroMobile-e85662c8d24eab8b0e88945e1337dcf2.png";